import React from 'react';
import './App.css';

const About1 = () => {
  return (
    <div className="about-container">
      <div className="about-grid">

        {/* Images Section */}
        <div className="about-images">
          <img src={`${process.env.PUBLIC_URL}/images/coco3.webp`} alt="Coco Garden" />
          <img src={`${process.env.PUBLIC_URL}/images/pacl8.webp`} alt="Event" />
          <img src={`${process.env.PUBLIC_URL}/images/wedd2.webp`} alt="Wedding" />
          <img src={`${process.env.PUBLIC_URL}/images/shoot15.webp`} alt="Photoshoot" />
        </div>

        {/* Content Section */}
        <div className="about-content">
          <h2 className="about-header">COCOLOCO GARDENS</h2>
          <h4 className="about-headerr">KAHATHUDUWA, SRI LANKA</h4>
          <p className="about-description">
            At Cocoloco Garden, we welcome simplicity as the core of our haven.
            Surrounded by the embrace of nature, we carefully craft moments that eloquently convey their beauty in silence.
            Every event, each retreat is like an experience.<br /><br />
            Join us in the art of celebrating life's simple pleasures, where every detail is a deliberate choice towards a more meaningful experience.
            Cocoloco Garden — where less becomes an unforgettable experience of more.
          </p>
          <div className="about-btn">
            <button className="btn">
              <a href="https://maps.app.goo.gl/BP9bzQYpodXjmwvm6" target="_blank" rel="noopener noreferrer">
                Get Directions
              </a>
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About1;
